import { z } from 'zod';
import { contentIdSchema } from './content-id.js';
import { effectSchema } from './effect.js';
/**
 * Шаг журнала персонажа (D4, rules-engine.md, раздел 5).
 *
 * Движку передаётся только `payload`: ни идентификатора строки,
 * ни времени записи, ни `character_id` он не видит. Это разделение
 * из раздела 5 — строка `character_journal_entry` есть хранение,
 * `payload` есть вход движка, и дублировать поля строки внутрь
 * `payload` запрещено.
 */
/**
 * Значение выбора: ссылка на контент либо литерал, если слот его
 * допускает (rules-engine.md, раздел 5).
 *
 * Список чисел — тоже литерал: так в журнал попадают результаты
 * бросков характеристик. Движок кости не бросает (D21.4), числа
 * приходят снаружи, но решение «взяты вот эти шесть чисел» — часть
 * шага и хранится вместе с ним, иначе журнал перестаёт быть полной
 * записью решений (D4).
 */
export const choiceValueSchema = z.union([
    contentIdSchema,
    z.string(),
    z.number(),
    z.boolean(),
    z.array(z.number().int()),
    z.record(z.string(), z.union([z.string(), z.number(), z.boolean()])),
]);
export const choiceSchema = z.strictObject({
    slot: z.string().min(1),
    value: choiceValueSchema,
});
/** Ровно два ключа: других в payload нет (rules-engine.md, раздел 5). */
export const journalPayloadSchema = z.strictObject({
    choices: z.array(choiceSchema),
    effects: z.array(effectSchema),
});
/**
 * Шаг журнала на входе движка: порядковый номер и payload.
 *
 * `stepIndex` нужен движку, потому что свёртка идёт строго
 * по возрастанию и потому что он попадает в провенанс как источник.
 */
export const journalStepSchema = z.strictObject({
    stepIndex: z.number().int().nonnegative(),
    /**
     * Что за решение записано шагом. `inventory` — действие
     * с предметом: взяли, выбросили, надели, сняли (D29 не при чём —
     * это D4: инвентарь такая же свёртка журнала, как и остальной лист).
     * `hp` — урон, лечение и временные хиты; `spell` — подготовка,
     * трата ячейки и концентрация; `rest` — долгий отдых, который
     * возвращает и то, и другое. `xp` — начисленный опыт, `condition` —
     * повешенное и снятое состояние: оба приходят командой мастера
     * (D3) и оба остаются решениями в журнале, а не полями рядом с ним.
     */
    kind: z.enum([
        'create',
        'level',
        'inventory',
        'hp',
        'spell',
        'rest',
        'xp',
        'condition',
        // Счётчик ресурса (D56): трата, возврат, свой счётчик и его
        // удаление. Отдельный вид, а не `hp`: восстанавливается он
        // по правилу своей записи, а не по правилу хитов.
        'resource',
    ]),
    payload: journalPayloadSchema,
});
//# sourceMappingURL=journal.js.map